import React from "react";

const NavBar = () => {
  return (
    <div>
      <div className="bg-light logobar">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center">
            <div className="p-4">
              <img
                src="./img/logo.jpg"
                height="90"
                alt=""
                style={{marginRight:"20px"}}
              />
              <img
                src="./img/companylogo.png"
                height="90"
                alt=""
              />
            </div>
            <div className="p-2 text-end">
              <div className="d-inline-block mx-3 compact align-middle">
                <span className="fs-3 fontStyle1">
                 Kathakali Mudra Recognition
                </span>
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
      <nav className="navbar navbar-expand-md navbar-dark bg-dark">
        <div className="container">
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
      
          <div className="collapse navbar-collapse" id="navbarNavDropdown">
            <ul className="navbar-nav mx-auto">
              <li className="nav-item">
                <a className="nav-link mx-2 active" aria-current="page" href="#">Mudra Recognition</a>
              </li>
              {/* <li className="nav-item">
                <a className="nav-link mx-2" href="#">Mudra Training Set</a>
              </li>
              <li className="nav-item">
                <a className="nav-link mx-2" href="#">Word Recognition</a>
              </li>
              <li className="nav-item">
                <a className="nav-link mx-2" href="#">Word Training Set</a>
              </li> */}
            </ul>
          </div>
        </div>
      </nav>
      
    </div>
  );
};

export default NavBar;
